import dayjs from 'dayjs'
import React from 'react'
import Modal from 'react-modal'
import { useSelector } from 'react-redux'
import ReactTable from 'react-table'

import useSWR from '../../../hooks/useSWR'

type Props = {
  lockId: String,
  onToggleTestDeliveryUsage: Function,
  isTestDeliveryUsageOpen: Boolean,
}

const TestDeliveryUsage = ({ isTestDeliveryUsageOpen, lockId, onToggleTestDeliveryUsage }: Props) => {
  const lock = useSelector((state) => state.collectionData.locks.find((l) => l._id === lockId))
  const carrierNames = useSelector((state) => state.collectionData.carriers.reduce((acc, c) => ({ ...acc, [c._id]: c.organization }), {}))
  const { data } = useSWR(isTestDeliveryUsageOpen && `/subject/admin/bi/${lockId}/test-deliveries`)

  return (
    <div style={{ marginTop: 10 }}>
      <button onClick={onToggleTestDeliveryUsage}>Användning av testleveranser</button>
      <Modal onRequestClose={onToggleTestDeliveryUsage} isOpen={isTestDeliveryUsageOpen}>
        <button style={{ float: 'right', borderRadius: 3 }} onClick={onToggleTestDeliveryUsage}>
          X
        </button>
        <div
          style={{
            padding: 7,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          <h3>{lock.custom_name}</h3>
          <h5>Användning av testleveranser senaste 60 dagarna</h5>
          <ReactTable
            data={data || []}
            filterable
            style={{ width: '100%' }}
            columns={[
              {
                Header: 'Eventtid:',
                id: 'created',
                accessor: (d) => dayjs(d.date).format('HH:mm - DD/MM/YY'),
              },
              {
                Header: 'Transportör:',
                id: 'carrier',
                accessor: (d) => carrierNames[d.carrier],
              },
              {
                Header: 'Aktiv containerleverans:',
                id: 'hadActiveDelivery',
                accessor: (d) => (d.hadActiveDelivery ? 'Ja' : 'Nej'),
              },
              {
                Header: 'Aktiv grindleverans:',
                id: 'hadActiveObservableDelivery',
                accessor: (d) => (d.hadActiveObservableDelivery ? 'Ja' : 'Nej'),
              },
            ]}
            NoDataComponent={() => null}
            showPagination={true}
            showPageSizeOptions={false}
            loading={!data}
            loadingText="Laddar..."
            pageSize={20}
            className="-striped -highlight"
            sortable={true}
          />
        </div>
      </Modal>
    </div>
  )
}

export default TestDeliveryUsage
